import type { ElementType, HTMLAttributes, ReactNode } from "react";
import styles from "./Container.module.css";

type ContainerProps = HTMLAttributes<HTMLElement> & {
  as?: ElementType;
  size?: "default" | "narrow" | "wide";
  children?: ReactNode;
};

export function Container({
  as: Tag = "div",
  size = "default",
  className,
  children,
  ...rest
}: ContainerProps) {
  const cls = [
    styles.container,
    size === "narrow" && styles.narrow,
    size === "wide" && styles.wide,
    className,
  ]
    .filter(Boolean)
    .join(" ");
  return (
    <Tag className={cls} {...rest}>
      {children}
    </Tag>
  );
}
